import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { filter } from 'rxjs';
import { FunnelLoginService } from '../../../services/funnel-login.service';
import { MlpCallbackContextService } from './mlp-callback-context.service';

@Component({
  selector: 'app-mlp-callback-link',
  imports: [MatIconModule],
  templateUrl: './mlp-callback-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MlpCallbackLinkComponent {
  protected readonly callback = inject(MlpCallbackContextService);
  private readonly kundeLogin = inject(FunnelLoginService);
  private readonly destroyRef = inject(DestroyRef);

  protected open(event: Event): void {
    event.preventDefault();
    if (!this.callback.loginRequired()) {
      this.callback.open();
      return;
    }

    this.kundeLogin
      .login({ mode: 'gated', reason: 'rueckruf' })
      .pipe(filter(Boolean), takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.callback.open());
  }
}
